module.exports = __webpack_public_path__ + "img/glass.b24c2714.png";